// extracted by css-extract-rspack-plugin
export default {"visual":"FlexSuiteRiverBreakout-module__visual__J5xob"};